// Сервис для работы с API интеграций B2B
import axios from 'axios';
import {
  BaseResponse,
  ChangeNetworkCodePayload,
  CreateIntegrationPayload,
  Integration,
  SetNetworkCodeActivePayload,
  UpdateIntegrationInfoPayload,
} from './types';

export class IntegrationsService {
  static API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/`;

  // Получить все интеграции
  static async getIntegrations(): Promise<Integration[]> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/all`;
    const response = await axios.get<Integration[]>(url);
    return response.data;
  }

  // Получить интеграцию по коду
  static async getIntegrationByCode(code: string): Promise<Integration> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/${code}`;
    const response = await axios.get<Integration>(url);
    return response.data;
  }

  // Создать интеграцию
  static async createIntegration(
    payload: CreateIntegrationPayload
  ): Promise<BaseResponse> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/create`;
    const response = await axios.post<BaseResponse>(url, payload);
    return response.data;
  }

  // Привязать сеть к интеграции
  static async addNetwork(
    payload: ChangeNetworkCodePayload
  ): Promise<BaseResponse> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/add/network`;
    const response = await axios.post<BaseResponse>(url, payload);
    return response.data;
  }

  // Отвязать сеть от интеграции
  static async removeNetwork(
    payload: ChangeNetworkCodePayload
  ): Promise<BaseResponse> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/remove/network`;
    const response = await axios.delete<BaseResponse>(url, { data: payload });
    return response.data;
  }

  // Изменить статус активности сети
  static async setNetworkActive(
    payload: SetNetworkCodeActivePayload
  ): Promise<BaseResponse> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/set/network/active`;
    const response = await axios.put<BaseResponse>(url, payload);
    return response.data;
  }

  // Обновить информацию об интеграции (front_url, sender)
  static async updateIntegrationInfo(
    payload: UpdateIntegrationInfoPayload
  ): Promise<BaseResponse> {
    const url = `${IntegrationsService.API_BASE_URL}b2b/integrations/update/info`;
    const response = await axios.post<BaseResponse>(url, payload);
    return response.data;
  }
}
